import { StreamView } from '@img-arena/consoles-api-streaming'
import { Column, COLUMN_CELL_TYPE } from '@/components/table/base'
import { formatNumberToSI } from '@/utils/formatNumberToSI'
import { secondsToHMS } from '@/utils/secondsToHMS'

export const EVENT_STREAMS_COLUMNS: Column<StreamView>[] = [
  {
    id: 'streamName',
    label: 'Event',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (eventName) => (eventName ? eventName : '-')
  },
  {
    id: 'totalViews',
    label: 'Total Views',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: 'totalDuration',
    label: 'Total Minutes',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (value) => formatNumberToSI(value, { space: true })
  },
  {
    id: 'uniqueViews',
    label: 'Unique Views',
    type: COLUMN_CELL_TYPE.NUMBER
  },
  {
    id: 'averageDuration',
    label: 'Average Duration',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (value) => secondsToHMS(value)
  }
]
